import { useContext } from 'react';

import { DesktopTargetViewSelectionContext } from './desktop-target-view-selection-context';

export const useDesktopTargetViewSelection = () =>
  useContext(DesktopTargetViewSelectionContext);
